import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { fetchLyrics } from './lyricsAPI';
import initialState from './initialState';

export const fetchLyricsAsync = createAsyncThunk(
  'lyrics/fetchLyrics',
  async (payload) => {
    const response = await fetchLyrics(payload, ()=>{});
    
    return {
      songId: response.songId,
      lyrics: response.lyrics
    };
  }
);


export const lyricsSlice = createSlice({
  name: 'lyrics',
  initialState,
  reducers: {
    resetLyrics: (state) => {
        state.status = 'idle';
        state.lyrics = [];
        state.songId = null;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchLyricsAsync.pending, (state) => {
        state.status = 'pending';
        state.lyrics = [];
        state.songId = null;
      })
      .addCase(fetchLyricsAsync.rejected, (state, action) => {
        state.status = 'rejected';
        state.lyrics = [];
        state.songId = null
      })
      .addCase(fetchLyricsAsync.fulfilled, (state, action) => {
        state.status = 'idle';
        state.lyrics = action.payload.lyrics;
        state.songId = action.payload.songId;
      });
  },
});

export const { resetLyrics } = lyricsSlice.actions;

export const selectLyricsLyrics = (state) => state.lyrics.lyrics;
export const selectLyricsStatus = (state) => state.lyrics.status;
export const selectLyricsSongId = (state) => state.lyrics.songId;

export default lyricsSlice.reducer;
